import React from 'react';
import Radium from 'radium';
import ReactNumeric from 'react-numeric';


class InputText extends React.Component {





    render() {

        const rowBlockLeft = {
            textAlign: 'left',
            paddingBottom: '2px',
            boxSizing: 'border-box',
            overflow: 'auto',
            height: '40px',
            lineHeight: '40px',
            // For mobile
            '@media (max-width: 992px)': {
                display: 'block'

            },

            '@media print': {
                width: '20%',
                display: 'inline',
                fontSize: '10px',
            }
        }

        const rowInputLeft = {
            overflow: 'auto',
            fontSize: '15px',
            border: '1px solid grey',
            paddingLeft: '8px',
            textAlign: 'left',
            float: 'right',
            backgroundColor: 'transparent',
            boxSizing: 'border-box',
            width: '100%',
            // For mobile
            '@media (max-width: 992px)': {
                width: '100%',
                boxSizing: 'border-box',
            },

            '@media print': {
                width: '40%',
                display: 'inline',
                boxSizing: 'content-box',
                fontSize: '10px',

            }
        }

        const customerInfoRow = {
            marginTop: '10px',
            overflow: 'auto',
            display: 'block'
        }


        return (
            this.props.inputtype === "cm" ?
                <div>
                    <div style={customerInfoRow}>



                        <ReactNumeric
                            style={rowInputLeft}
                            value="0"
                            currencySymbol=" cm"
                            currencySymbolPlacement="s"
                            minimumValue="0"
                            decimalCharacter="."
                            decimalPlaces="0"
                            digitGroupSeparator=""
                            onChange={(event, value) => {
                                console.log(event.target.value); // 1234.5
                                console.log(this.props.fieldname); // 1234.5
                                let  valuetosend= [value, this.props.fieldname]
                                this.props.getValue(valuetosend)
                            }}
                        />



                    </div>
                </div> :


                <div>
                    <div style={customerInfoRow}>



                        <input placeholder={this.props.placeholder}
                            style={rowInputLeft}

                            onChange={(event, value) => {
                                console.log(event.target.value); // 1234.5
                                console.log(this.props.fieldname); // 1234.5
                                let  valuetosend= [event.target.value, this.props.fieldname]
                                this.props.getValue(valuetosend)
                            }}
                        />



                    </div>
                </div>
        );
    }
}

InputText = Radium(InputText);
export default InputText;